import { FindEmailResponseType } from 'src/models/Account/FindEmail';
import { MyAccountDeleteResponseType } from 'src/models/Account/MyAccount';
import { ResendPasswordRequestType, ResendPasswordResponseType } from 'src/models/Account/ResendPassword';
import { ChangePasswordType, ResetPasswordResponseType } from 'src/models/Account/ResetPassword';
import { SignInRequestType, SigninResponseType } from 'src/models/Account/Signin';
import { SignUpRequestCancelledType, SignUpRequestType, SignupResponseType } from 'src/models/Account/Signup';
import { RecaptchaViewModelType } from 'src/models/common';
import { ApiFunctionType, httpPost, httpPostCancellable, httpGet } from 'src/utils/http';
import { deConfigurationSettingsSelector } from 'src/store/commonPart/selector';
import { store } from 'src/store/store';
import { GetSigninInfoType } from 'src/models/Account/User';

const getPath = (path: string) => `/account/profile/${path}`;

export const apiLoadUserModel = (): Promise<GetSigninInfoType> => httpGet(getPath('GetSignInInfo'));

/** get user info by email */
export const apiAccountFindEmail: ApiFunctionType<{
   Email: string, RecaptchaViewModel: RecaptchaViewModelType }, FindEmailResponseType> = httpPostCancellable(
  getPath('findemail')
);

/** reset password */
export const apiAccountResetPassword: ApiFunctionType<{ Email: string }, ResetPasswordResponseType> =
  httpPostCancellable(getPath('resetpassword'));

/** delete account */
export const apiDeleteAccount: ApiFunctionType<{ Password: string }, MyAccountDeleteResponseType> = httpPostCancellable(
  getPath('deleteaccount')
);

/** signin */
export const apiAccountSignin = ({
  email,
  password,
  rememberMe = false,
}: SignInRequestType): Promise<SigninResponseType> =>
  httpPost(getPath('signin'), {
    Email: email,
    Password: password,
    RememberMe: rememberMe,
  });

export const apiAccountSignInCancelled: ApiFunctionType<SignInRequestType, SigninResponseType> = httpPostCancellable(
  getPath('signin')
);

/** signup */
export const apiAccountSignup = ({
  Email,
  FirstName,
  LastName,
  Password,
  ConfirmPassword,
  MarketingOptIn,
  recaptchaToken,
  IsAdvocateUserTypeRequested,
}: SignUpRequestType): Promise<SignupResponseType> => {
  const { RecaptchaSiteKey } = deConfigurationSettingsSelector(store.getState());

  return httpPost(getPath('signup'), {
    Email,
    FirstName,
    LastName,
    Password,
    ConfirmPassword,
    MarketingOptIn,
    RecaptchaViewModel: {
      RecaptchaResponse: recaptchaToken,
      SiteKey: RecaptchaSiteKey,
    },
    IsAdvocateUserTypeRequested,
  });
};

export const apiAccountSignupCancelled: ApiFunctionType<SignUpRequestCancelledType, SignupResponseType> =
  httpPostCancellable(getPath('signup'));

export const apiAccountOUTERSignup = ({
  email,
  firstName,
  lastName,
  password,
  confirmPassword,
  RecaptchaViewModel,
}: {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  marketingOptIn: boolean;
  recaptchaToken: string;
  RecaptchaViewModel: RecaptchaViewModelType;
}): Promise<SignupResponseType> =>
  httpPost(getPath('signup'), {
    Email: email,
    FirstName: firstName,
    LastName: lastName,
    Password: password,
    ConfirmPassword: confirmPassword,
    MarketingOptIn: false,
    RecaptchaViewModel,
  });

/** reset password */
export const apiAccountChangePassword = (data: ChangePasswordType): Promise<ChangePasswordType> =>
  httpPost(getPath('changepassword'), data);

/** resend confirmed email */
export const apiAccountResendEmail: ApiFunctionType<ResendPasswordRequestType, ResendPasswordResponseType> =
 httpPostCancellable(
  getPath('resendconfirmemail')
);
